import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function CTAButton({
  className = '',
  href = '#offer',
  onClick
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  return <div className={`flex flex-col items-center ${className}`} data-id="element-180">
      <motion.a href={href} onClick={onClick} {...isExternal ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="block w-full sm:w-auto text-center bg-gradient-to-b from-amber to-[#C29732] text-charcoal font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-warm hover:shadow-warm-lg transition-shadow duration-300" data-id="element-181">
        GIVE MY PARENTS SMARTPHONE CONFIDENCE
      </motion.a>
    </div>;
}